import { useQueryClient } from '@tanstack/react-query'

import {
  useThreadsServicePostV1IndividualsByIndividualIdThreadsByThreadIdSummerize,
} from '../client/queries'
import {
  useNotesServiceGetV1IndividualsByIndividualIdNotesKey,
  useThreadsServiceGetV1IndividualsByIndividualIdThreadsKey,
} from '../client/queries/common'

export const useSummarizeThread = () => {
  const queryClient = useQueryClient()

  return useThreadsServicePostV1IndividualsByIndividualIdThreadsByThreadIdSummerize({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useNotesServiceGetV1IndividualsByIndividualIdNotesKey],
      })
      queryClient.invalidateQueries({
        queryKey: [useThreadsServiceGetV1IndividualsByIndividualIdThreadsKey],
      })
    },
  })
}
